<template>
    <div>
        <div v-if="feed">
            <article class="media">
                <h2 class="title is-2 is-pulled-left" style="margin-top:8px;">
                    <router-link to="/feeds">
                        <b-icon icon="chevron-left" size="is-small"></b-icon>
                    </router-link> &nbsp;
                </h2>
                <figure class="media-left is-pulled-left" v-if="feed.image_url">
                    <figure class="image is-64x64" >
                        <img @error="imageError" :src="feed.image_url" :alt="feed.name">
                    </figure>
                </figure>
                <div class="media-content">
                    <div class="content">
                        <h4 class="title is-4 heading-top-margin">
                            {{feed.name}}
                        </h4>
                        <p class="subtitle is-6">{{feed.type}}</p>
                    </div>
                </div>
            </article>
            
            <!-- tab menu -->
            <div class="tabs is-centered is-boxed">
                <ul>
                    <router-link active-class="is-active" :to="`/feeds/${feedId}`" tag="li" exact>
                        <a>Options</a>
                    </router-link>
                    <router-link v-if="isMajor" active-class="is-active" :to="`/feeds/${feedId}/fixtures`" tag="li" exact>
                        <a>Fixtures</a>
                    </router-link>
                    <router-link v-if="isMajor" active-class="is-active" :to="`/feeds/${feedId}/fixtures/today`" tag="li">
                        <a>Today</a>
                    </router-link>
                    <router-link v-if="isMajor" active-class="is-active" :to="`/feeds/${feedId}/fixtures/comingup`" tag="li">
                        <a>Coming Up</a>
                    </router-link>
                    <router-link v-if="isMajor" active-class="is-active" :to="`/feeds/${feedId}/fixtures/results`" tag="li">
                        <a>Results</a>
                    </router-link>
                    <router-link active-class="is-active" :to="`/feeds/${feedId}/articles`" tag="li" exact>
                        <a>Articles</a>
                    </router-link>
                    <router-link active-class="is-active" :to="`/feeds/${feedId}/videos`" tag="li" exact>
                        <a>Videos</a>
                    </router-link>
                    <router-link v-if="isMajor" active-class="is-active" :to="`/feeds/${feedId}/logs`" tag="li" exact>
                        <a>Logs</a>
                    </router-link>
                </ul>
            </div>

            <!-- sub pages inserted here -->
            <router-view></router-view>

        </div>
        <loading v-else></loading>
    </div>
</template>

<script>
import Loading from "@/components/Loading";
import { SET_FEED } from "@/store/mutations";
import { GET_FEED } from "@/store/actions";

export default {
  name: "feed",
  components: {
    Loading
  },
  mounted() {
    if (!this.feed || this.feed.id !== this.feedId) {
      this.getFeed();
    }
  },
  computed: {
    feedId() {
      return this.$route.params.id;
    },
    feed() {
      return this.$store.state.feed.item;
    },
    isMajor(){
      return this.feed.type !== 'Minor';
    }
  },
  methods: {
    getFeed() {
      this.$store.commit(SET_FEED, null);
      this.$store.dispatch(GET_FEED, this.feedId);
    },
    imageError(e){
      e.target.src = 'https://www.supersport.com/images/placeholder-flag.png';
    }
  }
};
</script>

<style scoped>
.heading-top-margin {
  margin-top: 6px;
}
</style>
